<template>
  <section>
    <div class="controls-wrap">
      <!-- Integration Field -->
      <div class="jobs-controls m-3">
        <h6 style="font-weight: 700; font-size: 18px">Pipeline</h6>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table table-striped custom-table" style="table-layout: auto">
        <thead class="bg-dark">
          <tr>
            <th nowrap scope="col" style="font-weight: 600">RATING</th>
            <th nowrap scope="col" style="font-weight: 600">POSITION</th>
            <th nowrap scope="col" style="font-weight: 600">&nbsp;</th>

            <th nowrap scope="col" style="font-weight: 600">LOCATION</th>
            <th nowrap scope="col" style="font-weight: 600">&nbsp;</th>
            <th nowrap scope="col" style="font-weight: 600">&nbsp;</th>
            <th nowrap scope="col" style="font-weight: 600">UPDATED</th>
            <th nowrap scope="col" style="font-weight: 600">STAGE</th>
            <th nowrap scope="col" style="font-weight: 600">ACTIONS</th>
          </tr>
        </thead>
        <tbody>
          <TableItem
            v-for="pipeline in getManagerCandidatePipelines"
            :key="pipeline.id"
            :pipeline="pipeline"
            :user="getManagerCandidateById"
            @newActivity="$emit('getNewActivities')"
            @updatePipeLine="getPipeLines"
          />
        </tbody>
      </table>
    </div>
    <ErrorList
      class="no-data-message"
      v-show="getManagerCandidatePipelines.length == 0"
      name="noPipelines"
    />

    <!-- Pagination -->
    <div class="d-flex justify-content-between bottom-controls">
      <div class="ml-auto" id="pagination">&nbsp;</div>
    </div>
  </section>
</template>

<script>
/* import Search from '@/components/common/Search/Search'; */
import { mapActions, mapGetters } from 'vuex';

/* import AddBtn from '../common/TableControlsAddBtn';
import CustomMainModal from '@/components/Modals/CustomMainModal';
import ManagerAddToPipelineBtnModal from './ManagerAddToPipelineBtnModal'; */
import { errorService } from '../../../services/errorService';
import TableItem from './ManagerCandidateItemPipelineTableItem';
import ErrorList from '@/components/common/errorsList';

import { stagesMixin } from '../../../mixins/stagesMixin';
import { qualificationMixin } from '../../../mixins/qualificationMixin';

export default {
  components: {
    TableItem,
    /* AddBtn,
    CustomMainModal,
    ManagerAddToPipelineBtnModal, */
    /*  Search, */
    ErrorList,
  },
  mixins: [stagesMixin, qualificationMixin],
  data: () => ({
    showModal: false,
    rating: 1,
    starPoints: [23, 2, 14, 17, 0, 19, 10, 34, 7, 50, 23, 43, 38, 50, 36, 34, 46, 19, 31, 17],
    isLoading: false,
    stages: {
      /* not_contacted */ 102: false,
      /* contacted */ 103: false,
      /* interviewing */ 104: false,
      /* conducting_test: false,
      checking_references: false,
      interviewed: false, */
      /* offered_employment */ 106: false,
      /* employed */ 107: false,
      /* no_longer_interested */ 108: false,
      /* not_in_consideration */ 109: false,
    },
    pipelineId: '',
    pipelineForUpdate: '',
    pipelineForDeleteId: '',
    sources: '',
    selectedQualification: 'qualification',
    selectedStage: 'stage',
    isSubmitted: false,
    pipelineForSubmit: {},
    candidateDocumentsFiles: [
      { id: '31', name: 'test candidate doc 1' },
      { id: '42', name: 'test candidate doc 2' },
      { id: '113', name: 'test candidate doc 3' },
    ],
    selectedDocuments: [],
    comment: '',
    isSeen: true,
  }),
  methods: {
    ...mapActions('managerStoreModule', [
      'retrieveManagerCandidatePipelines',
      'retrieveManagerUserProfile',
    ]),
    handleCheckboxChange() {
      console.log(this.selectedDocuments);
    },
    clearForm() {},
    setPipelineForUpdate(pipeline) {
      this.pipelineForUpdate = pipeline;
      this.pipelineId = pipeline['pipeline-id'];
      this.sources = pipeline['source-id'];

      this.stage = this.getStageMixin(pipeline.stage).value;
      this.qualification = this.getQualificationMixin(pipeline.qualification).value;
    },
    getPipeLines() {
      this.retrieveManagerCandidatePipelines({
        uuid: this.$route.params.manager_candidate_id,
        search_word: '',
        page: 1,
        count: 10,
      })
        .then(response => {
          this.rating = response.data.rating;
        })
        .catch(err => {
          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },
  },
  computed: {
    ...mapGetters('managerStoreModule', [
      'getManagerCandidatePipelines',
      'getManagerProfile',
      'getManagerCandidateById',
    ]),
  },
  mounted() {
    this.retrieveManagerUserProfile();
    this.retrieveManagerCandidatePipelines({
      uuid: this.$route.params.manager_candidate_id,
      search_word: '',
      page: 1,
      count: 10,
    })
      .then(response => {
        this.rating = response.data.rating;
      })
      .catch(err => {
        this.$toasted.error(errorService(err), {
          theme: 'bubble',
          icon: 'fa-times-circle',
          position: 'bottom-right',
          duration: 5000,
        });
      });
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.icon-wrapper {
  .svg-icon {
    width: 18px;
    height: 18px;
  }

  .edit {
    fill: #a7a7a7;
  }

  .submit {
    fill: #5bb75b;
  }
}

#stage {
  .stage-size {
    width: 12px;
    height: 12px;
  }
}

.icon-wrapper {
  svg {
    width: 16px;
    height: 18px;
  }
}

.truncate-item {
  a {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
  }
}

.location-color {
  color: #555;
}

.edit {
  fill: #a7a7a7;
}

.jobs-controls {
  .input-group {
    i {
      color: $color-table-location;
      position: absolute;
      pointer-events: none;
      top: 8px;
      right: 12px;
      font-size: 21px;
      z-index: 99;
    }

    .form-control {
      border-radius: 0.25rem !important;
    }
  }
}

.star-rating {
  position: relative;
  display: block;
  width: 100%;

  .reset-stars {
    position: absolute;
    font-size: 16.7px;
    cursor: pointer;
    top: 1px;
    right: -18px;
    color: #555;
    display: none;
  }

  &:hover {
    .reset-stars {
      display: block;
      right: 10px;
    }
  }
}

@media only screen and (max-width: 768px) {
  #stages-dropdown {
    flex: 1;

    .dropdown-toggle {
      width: 100%;
    }
  }

  .btn-success {
    display: none !important;
  }
}

@media only screen and (max-width: 576px) {
  .bottom-controls,
  .no-mobile {
    display: none !important;
  }

  .jobs-controls {
    .d-flex {
      display: block !important;

      .input-group {
        width: 100% !important;
      }
    }

    .dropup,
    .dropright,
    .dropdown,
    .dropleft {
      background: red;
    }
  }

  .list-unstyled.mobile-pipeline {
    font-family: $font-family-sans-lato;

    li {
      position: relative;
      padding: 6px 22px 6px 22px;
      border-bottom: 1px solid #ddd;

      a.username {
        display: block;
        font-size: 16px;
        font-weight: 700;
        text-decoration: none;
      }

      a.toggle-collapse {
        color: #666;
        position: absolute;
        top: 50%;
        right: -2px;
        transform: translate(0, -50%);
      }

      .d-flex:first-of-type {
        span {
          font-size: 14px;

          &:first-of-type {
            color: $color-orange;
            margin-right: auto;
          }

          &:nth-of-type(2) {
            color: #5f5f5f;
          }
        }
      }

      .d-flex:nth-of-type(2) {
        span {
          font-size: 14px;

          &:first-of-type {
            color: #5f5f5f;
            margin-right: auto;
          }

          &:nth-of-type(2) {
            color: #5f5f5f;
            position: relative;

            .status {
              border-radius: 50%;
              display: inline-block;
              width: 11px;
              height: 11px;
              background: red;
              margin: 0px 5px 0 0;

              &.employment {
                background: $color-status-active;
              }

              &.self-employment {
                background: $color-base-blue;
              }

              &.mixed-orange {
                background: $color-orange;
              }
            }
          }
        }
      }

      img {
        position: absolute;
        top: 8px;
        right: 22px;
      }
    }
  }
}

.dropdown {
  button {
    box-shadow: 0px 2px 3px #0000000d;
    background: url("data:image/svg+xml;utf8,<svg viewBox='0 0 140 140' width='14' height='14' xmlns='http://www.w3.org/2000/svg'><g><path d='m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z' fill='grey'/></g></svg>")
      no-repeat !important;
    background-position: right 3px top 50% !important;
    margin-right: 3px !important;
    -webkit-appearance: none;
    -moz-appearance: none;

    &::after {
      display: none;
      /*  -webkit-appearance: none;
      -moz-appearance: none; */
    }

    color: #4d4f5c;
  }

  .dropdown-menu {
    padding: 8px 12px;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.4);

    ul > li:not(:last-child) {
      margin-bottom: 1rem;
    }

    width: 250px;
    margin-top: 5px;

    .custom-control {
      margin-bottom: 0;
    }
  }

  button {
    background-color: #fff;
    border: 1px solid #d7dae2;
    border-radius: 4px;
    width: 250px;
    text-align: left;
  }
}

@media only screen and (max-width: 576px) {
  .dropdown.ml-3 {
    margin-left: 0 !important;

    .btn {
      width: 100%;
      margin: 12px 0;
    }
  }
}
</style>
